<template>
  <v-tooltip
    :top="top"
    :right="right"
    :bottom="bottom"
    :left="left"
    :content-class="contentClass"
  >
    <slot slot="activator" name="activator" />
    <slot />
  </v-tooltip>
</template>

<script>
export default {
  props: {
    top: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentClass() {
      let classes = ['small-tooltip'];

      if (this.top) {
        classes.push('small-tooltip--top');
      }

      if (this.right) {
        classes.push('small-tooltip--right');
      }

      if (this.bottom) {
        classes.push('small-tooltip--bottom');
      }

      if (this.left) {
        classes.push('small-tooltip--left');
      }

      return classes.join(' ');
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/_responsive.scss';
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/_mixins.scss';

.small-tooltip {
  background-color: $dark-blue;
  padding: rem(5px 10px);
  border-radius: rem(3px);

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
  }

  &--right {
    &:after {
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-right: 5px solid $dark-blue;
      right: 100%;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  &--left {
    &:after {
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 5px solid $dark-blue;
      left: 100%;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  &--bottom {
    &:after {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid $dark-blue;
      bottom: 100%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  &--top {
    &:after {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid $dark-blue;
      top: 100%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}
</style>
